class ReferralsAndRewards {

  constructor(userBasePath, apiClient) {

    this.basePath = `${userBasePath}`;
    this.apiClient = apiClient;

  }

  async getReferAndEarnDetailsByStartupUserId() {

    const path = `${this.basePath}/refer-and-earn-details`;

    return this.apiClient.get(path, {}, {});

  }

  async getReferrerRewardsByStartupUserIdAndQueryOptions(queryOptions) {

    const path = `${this.basePath}/referrer-rewards`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async updateReferrerRewardById(referrerRewardId, reward) {

    const path = `${this.basePath}/referrer-rewards/:referrerRewardId`;

    return this.apiClient.put(path, { referrerRewardId }, {}, reward);

  }

  async getReferrerRewardsSummariesByStartupUserId() {

    const path = `${this.basePath}/referrer-rewards-summary`;

    return this.apiClient.get(path, {}, {});

  }

}

export default ReferralsAndRewards;